import { FCX } from "@datassential/platform-ui-lib";
import {
    useConsumerGroupsContext
} from "@pages/Profile/components/ConsumerGroups/ConsumerGroups";
import { useBrands } from "@core/CommonDataContext";
import {
    ConsumerGroupsTableItem,
    useConsumerGroupsTableMetrics
} from "./ConsumerGroupsTableConfig";
import { useMemo } from "react";
import Common from "@pages/Profile/components/ConsumerGroups/Common";

const Brands: FCX = (props) => {
    const getMetricsData = useConsumerGroupsTableMetrics();
    const { data } = useConsumerGroupsContext();

    const options = useBrands();

    const itemsData = useMemo(
        (): ConsumerGroupsTableItem[] => {
            return (data.cpgBrands ?? []).map((item) => {
                const itemData = options.find((i) => i.id === item.id);

                return {
                    id: item.id,
                    name: itemData?.name ?? '',
                    baseSize: item.base ?? 0,
                    metrics: getMetricsData(item.metrics ?? []),
                };
            });
        },
        [options, data.cpgBrands, getMetricsData]
    );

    return (
        <Common {...props} data={itemsData} isVirtualized/>
    );
}

export default Brands;